import React, {useMemo} from "react";
import { SubTitleTab } from "../../../../../../../component/page-components";
import { Col, DatePicker, Input, Radio, Row } from "antd";
import changeToSentecesText from "../../../../../../../util/changeToSentecesText";
import { IconDeleteImg, ProfileKosong } from "../../../../../../../asset";
import { getImgName } from "../../../../../../../util";
import DropdownListTitle from "../../../../../../../component/dropdown-list/ddl-title";
import DropdownListMaritalStatus from "../../../../../../../component/dropdown-list/ddl-marital-status";
import TextArea from "antd/es/input/TextArea";
import DropdownSearchCountry from "../../../../../../../component/dropdown-search/dds-region/dds-country";
import DropdownSearchProvince from "../../../../../../../component/dropdown-search/dds-region/dds-province";
import DropdownSearchDistrict from "../../../../../../../component/dropdown-search/dds-region/dds-district";
import DropdownSearchSubDistrict from "../../../../../../../component/dropdown-search/dds-region/dds-subdistrict";
import DropdownSearchUrbanVillage from "../../../../../../../component/dropdown-search/dds-region/dds-urban-village";
import DropdownSearchPostalCode from "../../../../../../../component/dropdown-search/dds-region/dds-postal-code";
import MSSAddDayOff from "../../../../../../../component/mss/day-off/add-day-off";
import onKeyPressNumber from "../../../../../../../util/onKeyPressNumber";
import style from "../../../DeliveryAssociate.module.css";
import Dragger from "../../../../../../../component/dragger/Dragger";

const TabDriverProfileOutsources = ({
  PhotoDriver,
  setPhotoDriver,
  clearCurrImg,
  FormInput,
  titleId,
  setTitleId,
  gender,
  countryId,
  setCountryId,
  provinceId,
  setProvinceId,
  districtId,
  setDistrictId,
  subDistrictId,
  setSubDistrictId,
  urbanVillageId,
  setUrbanVillageId,
  postalCodeId,
  setPostalCodeId,
  FormInputShiftStart,
  FormInputShiftEnd,
  valueDayOff,
  setValueDayOff,
  FormInputDate,
  handleInputForm,
  maritalStatus,
  setMaritalStatus,
  handleChangeDate,
  FormInputPhone,
  handleChangePhone,
  handleChangeFormInputShiftStart, handleChangeFormInputShiftEnd,
  handleFormInput

}) => {
  const NewPhotoDriver = useMemo(() => {
    if (PhotoDriver || PhotoDriver !== "" || PhotoDriver !== []){
      return typeof PhotoDriver
    }
    return ""
  },[PhotoDriver]);

  return (
    <>
      <div className="flex mt-5">
        <div className="basis-1/2">
          <span className="sub-title-pages mb-5">Driver Profile</span>
          <div className="columns mt-5">
            <div className="container-field">
              <SubTitleTab title="Driver Type" />
              <Input
                size="large"
                value={changeToSentecesText("Outsources")}
                disabled
              />
            </div>
            <div className="container-field">
              <SubTitleTab title="Driver Photo (Optional)" />
              {!PhotoDriver || PhotoDriver === "" || PhotoDriver === [] ? (
                <Dragger
                  selectedFileList={PhotoDriver}
                  setSelectedFileList={setPhotoDriver}
                />
              ) : (
                <div className="border-2 w-full h-[118px] px-[24px] py-[12px] border-dashed rounded-md">
                  <div className="border-2 w-full h-[90px] rounded-md flex justify-between items-center p-[12px]">
                    <div className="w-[66px] h-[66px] border ">
                      <img
                        id="company-logo"
                        className="w-[66px] h-[66px]"
                        src={PhotoDriver !== "" && NewPhotoDriver === "string" ? PhotoDriver :
                          PhotoDriver && PhotoDriver.length ? URL.createObjectURL(PhotoDriver[0].originFileObj)
                            : ProfileKosong}
                        alt="company-logos"
                      />
                    </div>
                    <div
                      id="image-name"
                      className="font-roboto font-normal text-sm text-black-300"
                    >
                      {
                        NewPhotoDriver === "string" ? getImgName(PhotoDriver) :
                        NewPhotoDriver === "object" ? PhotoDriver[0]?.name :
                          "tidak ada foto"}
                    </div>
                    <div>
                      <img
                        id="icon-delete-images"
                        className="cursor-pointer"
                        src={IconDeleteImg}
                        alt="delete-icon"
                        onClick={clearCurrImg}
                      />
                    </div>
                  </div>
                </div>
              )}
            </div>
            <div className="container-field">
              <SubTitleTab title="Username" />
              <Input
                size="large"
                placeholder="Type Username"
                disabled
                value={FormInput?.username}
              />
            </div>
            <div className="container-field">
              <SubTitleTab title="Title (Optional)" />
              <DropdownListTitle
                placeholder={"Select Title"}
                valueDDS={titleId}
                setValueDDS={setTitleId}
              />
            </div>
            <div className="container-field">
              <SubTitleTab title="First Name" />
              <Input
                size="large"
                value={FormInput?.first_name}
                placeholder="Type First Name"
                onChange={(evt) =>
                  handleInputForm(evt.target.value, "first_name")
                }
              />
            </div>
            <div className="container-field">
              <SubTitleTab title="Last Name" />
              <Input
                size="large"
                value={FormInput?.last_name}
                placeholder="Type Last Name"
                onChange={(evt) =>
                  handleInputForm(evt.target.value, "last_name")
                }
              />
            </div>
            <div className="container-field">
              <SubTitleTab title="ID Card/NIK (Optional)" />
              <Input
                size="large"
                value={FormInput?.nik}
                placeholder="Type NIK"
                onChange={(evt) => handleInputForm(evt.target.value, "nik")}
              />
            </div>
            <div className="container-field">
              <SubTitleTab title="Phone" />
              <Input
                addonBefore="+62"
                size="large"
                value={FormInputPhone?.phone}
                placeholder="Type Phone"
                maxLength={11}
                onKeyPress={(e) => onKeyPressNumber(e)}
                onChange={(evt) => handleChangePhone(evt.target.value, "phone")}
              />
            </div>
            <div className="container-field">
              <SubTitleTab title="Email" />
              <Input
                size="large"
                value={FormInput?.email}
                placeholder="Type Email"
                disabled
              />
            </div>
            <div className="container-field">
              <SubTitleTab title="Marital Status (Optional)" />
              <DropdownListMaritalStatus
                placeholder={"Select Marital Status"}
                valueDDS={maritalStatus}
                setValueDDS={setMaritalStatus}
              />
            </div>
            <div className="container-field">
              <SubTitleTab title="Gender (Optional)" />
              <Radio.Group
                // onChange={(evt) => handleChangeGender(evt.target.value)}
                value={gender}
                className={style.radioBtn}
              >
                <Radio value="Male" className=" font-roboto-medium text-[20px]">
                  Male
                </Radio>
                <Radio
                  value="Female"
                  className=" font-roboto-medium text-[20px]"
                >
                  Female
                </Radio>
              </Radio.Group>
            </div>
            <div className="container-field">
              <SubTitleTab title="Birth Place (Optional)" />
              <Input
                size="large"
                value={FormInput?.birth_place}
                placeholder="Type Birth Place"
                onChange={(evt) =>
                  handleInputForm(evt.target.value, "birth_place")
                }
              />
            </div>
            <div className="container-field">
              <SubTitleTab title="Birth Date (Optional)" />
              <DatePicker
                size="large"
                value={FormInputDate?.date_of_birth}
                placeholder="Type Birth Date"
                onChange={(evt) => handleChangeDate(evt, "date_of_birth")}
                format={"DD MMMM YYYY"}
              />
            </div>
            <span className="sub-title-pages my-5">Emergency Contact</span>
            <div className="container-field">
              <SubTitleTab title="Name" />
              <Input
                size="large"
                value={FormInput?.emergency_contact_name}
                placeholder="Type Name"
                onChange={(evt) =>
                  handleInputForm(evt.target.value, "emergency_contact_name")
                }
              />
            </div>
            <div className="container-field">
              <SubTitleTab title="Relationship (Optional)" />
              <Input
                size="large"
                value={FormInput?.emergency_contact_relationship}
                placeholder="Type Name"
                onChange={(evt) =>
                  handleInputForm(
                    evt.target.value,
                    "emergency_contact_relationship"
                  )
                }
              />
            </div>
            <div className="container-field">
              <SubTitleTab title="Phone" />
              <Input
                addonBefore="+62"
                size="large"
                value={FormInputPhone?.emergency_contact_no_hp}
                placeholder="Type Phone"
                onKeyPress={(e) => onKeyPressNumber(e)}
                maxLength={12}
                onChange={(evt) =>
                  handleChangePhone(evt.target.value, "emergency_contact_no_hp")
                }
              />
            </div>
            <div className="container-field">
              <SubTitleTab title="Address" />
              <TextArea
                value={FormInput?.emergency_contact_address}
                onChange={(evt) =>
                  handleInputForm(evt.target.value, "emergency_contact_address")
                }
                rows={5}
              />
            </div>
          </div>
        </div>
        <div className="basis-1/2">
          <span className="sub-title-pages mb-5">Address</span>
          <div className="columns mt-5">
            <div className="container-field">
              <SubTitleTab title="Country" />
              <DropdownSearchCountry
                placeholder={"Select Country"}
                valueDDS={countryId}
                setValueDDS={setCountryId}
              />
            </div>
            <div className="container-field">
              <SubTitleTab title="Province" />
              <DropdownSearchProvince
                placeholder={"Select Province"}
                countryId={countryId}
                valueDDS={provinceId}
                setValueDDS={setProvinceId}
              />
            </div>
            <div className="container-field">
              <SubTitleTab title="District" />
              <DropdownSearchDistrict
                placeholder={"Select District"}
                countryId={countryId}
                provinceId={provinceId}
                valueDDS={districtId}
                setValueDDS={setDistrictId}
              />
            </div>
            <div className="container-field">
              <SubTitleTab title="Sub District" />
              <DropdownSearchSubDistrict
                placeholder={"Select Sub District"}
                countryId={countryId}
                districtId={districtId}
                valueDDS={subDistrictId}
                setValueDDS={setSubDistrictId}
              />
            </div>
            <div className="container-field">
              <SubTitleTab title="Urban Village" />
              <DropdownSearchUrbanVillage
                placeholder={"Select Urban Village"}
                countryId={countryId}
                subDistrictId={subDistrictId}
                valueDDS={urbanVillageId}
                setValueDDS={setUrbanVillageId}
              />
            </div>
            <div className="container-field">
              <SubTitleTab title="Address" />
              <TextArea
                value={FormInput?.address}
                rows={5}
                onChange={(evt) => handleInputForm(evt.target.value, "address")}
              />
            </div>
            <div className="container-field">
              <div style={{ width: "80%" }}>
                <div className="w-[500px] flex gap-[16px]">
                  <div className="container-field w-[200]">
                    <SubTitleTab title="Neighbourhood (Optional)" />
                    <Input
                      size="large"
                      placeholder="Type Neighbourhood"
                      onKeyPress={(e) => onKeyPressNumber(e)}
                      value={FormInput?.neighbour}
                      maxLength={3}
                      onChange={(evt) =>
                        handleInputForm(evt.target.value, "neighbour")
                      }
                    />
                  </div>
                  <div className="container-field w-[200]">
                    <SubTitleTab title="Hamlet (Optional)" />
                    <Input
                      size="large"
                      placeholder="Type Hamlet"
                      onKeyPress={(e) => onKeyPressNumber(e)}
                      value={FormInput?.hamlet}
                      maxLength={3}
                      onChange={(evt) =>
                        handleInputForm(evt.target.value, "hamlet")
                      }
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="container-field">
              <SubTitleTab title="Postal Code" />
              <DropdownSearchPostalCode
                placeholder={"Select Postal Code"}
                urbanVillageId={urbanVillageId}
                valueDDS={postalCodeId}
                setValueDDS={setPostalCodeId}
              />
            </div>
            <span className="sub-title-pages my-5">Job Description</span>
            <div className="container-field">
              <SubTitleTab title="Shift Start" />
              <div className=" w-2/6 h-[47px]">
                <Row>
                  <Col span={10} className="pr-2 ">
                    <Input
                      style={{ height: "47px" }}
                      placeholder="00"
                      maxLength={2}
                      onKeyPress={(e) => onKeyPressNumber(e)}
                      value={FormInputShiftStart?.shift_start_hours}
                      onChange={(evt) => handleChangeFormInputShiftStart(evt.target.value, "shift_start_hours") }
                    />
                  </Col>
                  <Col>
                    <p className="mr-1 text-2xl font-bold font-roboto text-black-100">
                      :
                    </p>
                  </Col>
                  <Col span={10}>
                    <Input
                      style={{ height: "47px" }}
                      placeholder="00"
                      maxLength={2}
                      onKeyPress={(e) => onKeyPressNumber(e)}
                      value={FormInputShiftStart?.shift_start_minutes}
                      onChange={(evt) => handleChangeFormInputShiftStart(evt.target.value, "shift_start_minutes") }
                    />
                  </Col>
                </Row>
              </div>
            </div>
            <div className="container-field">
              <SubTitleTab title="Shift End" />
              <div className=" w-2/6 h-[47px]">
                <Row>
                  <Col span={10} className="pr-2 ">
                    <Input
                      style={{ height: "47px" }}
                      placeholder="00"
                      maxLength={2}
                      onKeyPress={(e) => onKeyPressNumber(e)}
                      value={FormInputShiftEnd?.shift_end_hours}
                      onChange={(evt) => handleChangeFormInputShiftEnd(evt.target.value, "shift_end_hours") }
                    />
                  </Col>
                  <Col>
                    <p className="mr-1 text-2xl font-bold font-roboto text-black-100">
                      :
                    </p>
                  </Col>
                  <Col span={10}>
                    <Input
                      style={{ height: "47px" }}
                      placeholder="00"
                      maxLength={2}
                      onKeyPress={(e) => onKeyPressNumber(e)}
                      value={FormInputShiftEnd?.shift_end_minutes}
                      onChange={(evt) => handleChangeFormInputShiftEnd(evt.target.value, "shift_end_minutes") }
                    />
                  </Col>
                </Row>
              </div>
            </div>
            <div className="container-field">
              <SubTitleTab title="Day Off" />
              <MSSAddDayOff
                placeholder={"Select Day Off"}
                val={valueDayOff}
                setVal={setValueDayOff}
              />
            </div>
            
      <div className='container-field'>
        <SubTitleTab title="Daily Salary" />
        <Input
          size="large"
          placeholder="Type Daily Salary"
          onKeyPress={(e) => onKeyPressNumber(e)}
          onChange={(evt) => {
            handleFormInput(evt.target.value, "daily_salary");
          }}
          value={FormInput?.daily_salary}
          addonBefore="IDR"
          // maxLength={13}
          // status={FormError?.daily_salary ? "error" : null}
        />
        <div className="text-red-100">
          {/* {FormError?.daily_salary
            ? FormError?.daily_salary
            : false} */}
        </div>
      </div>
      <div className='container-field'>
        <SubTitleTab title="Hourly Salary" />
        <Input
          size="large"
          placeholder="Type Hourly Salary"
          value={FormInput?.hourly_salary}
          addonBefore="IDR"
          disabled
        />
      </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TabDriverProfileOutsources;
